export function getIsEnter(event: any): boolean {
  return (event.keyCode === 13 || event.keyCode === 10) && event.ctrlKey
}
export function getEventIsSubmitForm(event: any): boolean {
  return getIsEnter(event) && event.ctrlKey
}
